<div class="row" *ngIf="!this.loading">
  <div class="col-md-12 popin-container ">
    <div class="title text-center">
      <h1><strong>{{ this.title }}</strong></h1>
    </div>
    <div class="autocomplete">
      <form [formGroup]="popinForm">
        <mat-form-field class="group col-md-12" appearance="legacy" [hideRequiredMarker]="false">
          <input name="autocompleteField" class="input" matInput (ngModelChange)="change($event)"
                 [placeholder]="'Entrez votre société'" formControlName="autocompleteField"
                 [matAutocomplete]="auto" required/>
          <mat-autocomplete class="ac" #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngIf="this.isLoading" class="is-loading">
              <div style="float: left;">
                <mat-spinner diameter="25"></mat-spinner>
              </div>
              <div *ngIf="this.error3s"
                   class="matError"
                   style="font-size: 12px;margin-left: 50px;white-space: normal;line-height: 15px;text-align: center">
                Votre recherche est trop longue ? Essayez d'ajouter le code postal !
              </div>
            </mat-option>
            <ng-container *ngIf="!this.isLoading">
              <mat-option class="opt" style='padding:0;line-height: 20px;height: 55px;' *ngFor="let org of AutoComplete$"
                          [value]="org">
                <div style='display:flex;'>
                  <div class='container'
                       style='display: flex;flex-direction: column;flex: 1;padding-left:10px;max-width: 50%;'>
                    <span style="font-size:15px;text-overflow: ellipsis;overflow: hidden; ">{{org.companyName}}</span>
                    <small style="font-size:12px; text-overflow: ellipsis;overflow: hidden;">
                      {{org.commercialName != null ? org.commercialName + ' - ' : ''}}
                      {{org.ville}}
                    </small>
                  </div>
                  <div class='container'
                       style='display: flex;flex-direction: column;flex: 1;align-items: flex-end;padding-right:10px;max-width: 50%;min-width: 0;'>
                    <small style="font-size:12px;">{{org.siren}}</small>
                    <small style="font-size:12px;white-space: nowrap;max-width: 50%;text-overflow: ellipsis;overflow: hidden;">{{org.website}}</small>
                  </div>
                </div>
              </mat-option>
            </ng-container>
          </mat-autocomplete>
          <mat-icon class="icon" matTooltip="Choisissez une Société" matSuffix>search</mat-icon>
        </mat-form-field>
      </form>
    </div>
    <div class="customerBox" *ngIf="this.noresult">
      <mat-icon class="icon valign-error" matSuffix>error</mat-icon>
      <strong class="warning-title">Société inconnue</strong><br>
      Réessayez en commençant par taper le code postal de votre entreprise, suivi de son nom.
    </div>
    <div class="text-center margin-top-20" *ngIf="newCompanyLinkIsActive">
      <a (click)="newCompanyRedirect()" style="cursor: pointer;">{{ this.newCompanyLinkTitle }}</a>
    </div>
  </div>
</div>
